export default __webpack_public_path__ + "static/media/operationIcon.97523ab4.svg";